import { pathOr } from 'ramda';

/**
 * Redemption method mapping for easier use
 */
const redemptionMethodMap = {
  pin: [2],
  voucher: [4, 5, 6, 7],
};

/**
 * Get the huggg redemption method code from the provided huggg.
 *
 * @param {Object} huggg
 * @returns {Integer} Defaults to 0
 */
export const getRedemptionMethodID = (huggg) =>
  pathOr(0, ['purchase', 'brand', 'integration_id'], huggg);

/**
 * Is the provided huggg a pin redemption huggg.
 *
 * @param {Object} huggg
 * @returns {Boolean}
 */
export const isPinRedeem = (huggg) =>
  redemptionMethodMap.pin.indexOf(getRedemptionMethodID(huggg)) > -1;

/**
 * Is the provided huggg a voucher redemption huggg.
 * @param {Object} huggg
 * @returns {Boolean}
 */
export const isVoucherRedeem = (huggg) =>
  redemptionMethodMap.voucher.indexOf(getRedemptionMethodID(huggg)) > -1;

/**
 * Does the provided huggg have a known redemption method in Sangria.
 *
 * @param {Object} huggg
 * @return {Boolean}
 */
export const isValidRedemptionMethod = (huggg) =>
  [isPinRedeem, isVoucherRedeem].some((method) => method(huggg));

export const canRedeem = (huggg) => {
  const excludedHugggTypes = ['golden'];

  return (
    isValidRedemptionMethod(huggg) &&
    excludedHugggTypes.indexOf(huggg.type) === -1
  );
};
